import * as actionTypes from './actionTypes';
import { bookingApi } from 'services/http';
import { alertError } from 'services/alerts';
import { updateSingleAppointmentInList } from 'src/views/practitioner/Appointments/reducer/actions';
import { updateActiveAppointment } from 'src/views/practitioner/Appointment/reducers/actions';

export const triggerWorkflow = (trigger, id, data) => dispatch => {
  const body = {
    ...data,
    externalAppointmentId: id
  };

  bookingApi
    .post('workflows/appointments/' + trigger, body)
    .then(({ data }) => {
      dispatch(updateActiveAppointment({ appointment: data }));
      dispatch(updateSingleAppointmentInList(id, { appointment: data, updateFromSockets: false }));
      dispatch(triggerWorkflowSuccess(data));
      dispatch(loadWorkflowTimeline(id));
    })
    .catch(({ response }) => {
      if (response && response.status !== 400 && response.status !== 401) {
        alertError();
      }
      dispatch(
        updateSingleAppointmentInList(id, {
          errorTimeStamp: new Date().getTime()
        })
      );
      dispatch(triggerWorkflowError());
    });
};

const triggerWorkflowSuccess = data => ({
  type: actionTypes.TRIGGER_WORKFLOW_SUCCESS,
  payload: data
});

const triggerWorkflowError = () => ({
  type: actionTypes.TRIGGER_WORKFLOW_ERROR
});

export const loadWorkflowTimeline = externalAppointmentId => dispatch => {
  bookingApi
    .get(`/workflows/appointments/${externalAppointmentId}/timeline`, {
      withoutLoader: true
    })
    .then(({ data }) => {
      dispatch(loadWorkflowTimelineSuccess(data));
    })
    .catch(() => {
      dispatch(loadWorkflowTimelineError());
    });
};

const loadWorkflowTimelineSuccess = data => ({
  type: actionTypes.LOAD_WORKFLOW_TIMELINE_SUCCESS,
  payload: data
});

const loadWorkflowTimelineError = () => ({
  type: actionTypes.LOAD_WORKFLOW_TIMELINE_ERROR
});
